import { Ionicons } from "@/src/components/ui/ionicons";
import { border, surface, text } from "@/src/theme/tokens";
import { type Href, router } from "expo-router";
import { Platform, Pressable } from "react-native";

export function WebBackButton({ fallbackHref }: { fallbackHref: Href }) {
  if (Platform.OS !== "web") return null;

  const goBack = () => {
    if (router.canGoBack()) router.back();
    else router.replace(fallbackHref);
  };

  return (
    <Pressable
      onPress={goBack}
      accessibilityRole="button"
      accessibilityLabel="Retour"
      hitSlop={8}
      style={({ pressed }) => ({
        width: 40,
        height: 40,
        borderRadius: 12,
        backgroundColor: surface.primary,
        borderWidth: 1,
        borderColor: border.subtle,
        alignItems: "center",
        justifyContent: "center",
        opacity: pressed ? 0.72 : 1,
      })}
    >
      <Ionicons name="chevron-back" size={20} color={text.primary} />
    </Pressable>
  );
}
